import React from "react";
import { motion } from "framer-motion";

const Why = () => {
  return (
    <section className="text-black bg-gray-100 py-16 px-6 md:px-12">
      <div className="container mx-auto flex flex-col md:flex-row items-center">
        
        {/* Left Content */}
        <div className="md:w-1/2 space-y-6">
          <h2 className="text-3xl md:text-4xl font-bold">WHY MEGASCALE ?</h2>
          <p className="text-lg ">
            Megascale gives live project training so our trainee engineers can get a better chance to improve their skills. 
            We are here to help them choose their stream as per their area of interest. For training, there are senior IT 
            professionals to train students. Megascale Training is here to help you get a better job as per your technical 
            skills and ability. Candidates can find jobs as per technologies, area, and top software company-wise.
          </p>

          {/* Bullet Points */}
          <ul className="list-disc text-lg pl-6">
            <li>Training by Sr. IT Professionals</li>
            <li>Placements Assistance</li>
            <li>100% focus on Practical knowledge</li>
            <li>Live Project Experience</li>
            <li>Flexible Timing</li>
            <li>World Class Infrastructure</li>
          </ul>
        </div>

        {/* Right Image with Animation */}
        <motion.div 
          className="md:w-1/2 flex justify-center mt-8 md:mt-0"
          initial={{ opacity: 0, y: 300 }} // Start position (hidden + below)
          whileInView={{ opacity: 1, y: 0 }} // Animate to normal position
          transition={{ duration: 1, ease: "easeOut" }} // Smooth transition
          viewport={{ once: true }} // Runs only once when in view
        >
          <img 
            src="/Banner/girl-1.png" 
            alt="Why MegaScale" 
            className="max-w-sm md:max-w-md lg:max-w-lg"
          />
        </motion.div>

      </div>
    </section>
  );
};

export default Why;
